module.exports = __webpack_public_path__ + "img/img.48348177.png";